import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useConfig } from '../config/ConfigContext';
import { updatePageMetaTags } from '../utils/pageMetaUpdater';

/**
 * Component that listens to route changes and updates meta tags accordingly
 * This ensures proper sharing previews for all pages
 */
const MetaTagsUpdater = () => {
  const location = useLocation();
  const { config } = useConfig();

  useEffect(() => {
    if (!config) return;

    // Parse the current path
    const path = location.pathname;
    const pathSegments = path.split('/').filter(Boolean);
    
    // Determine which page we're on and update meta tags
    if (path === '/' || path === '/classic') {
      updatePageMetaTags(config, 'home');
    } else if (path === '/about') {
      updatePageMetaTags(config, 'about');
    } else if (path === '/support') {
      updatePageMetaTags(config, 'support');
    } else if (path === '/events') {
      updatePageMetaTags(config, 'events');
    } else if (path === '/publications') {
      updatePageMetaTags(config, 'publications');
    } else if (pathSegments[0] === 'speaker' && pathSegments[1]) {
      const speakerName = decodeURIComponent(pathSegments[1]);
      updatePageMetaTags(config, 'speaker', { speakerName });
    } else if (pathSegments[0] === 'events' && pathSegments[1]) {
      const eventName = decodeURIComponent(pathSegments[1]);
      updatePageMetaTags(config, 'event', { 
        customTitle: eventName,
        path: path 
      });
    } else if (pathSegments[0] === 'series' && pathSegments[1]) {
      const seriesName = decodeURIComponent(pathSegments[1]);
      updatePageMetaTags(config, 'series', { 
        customTitle: seriesName,
        path: path 
      });
    } else if (pathSegments[0] === 'lecture' && pathSegments[1]) {
      // For lecture pages, we'll use the lecture title if available
      updatePageMetaTags(config, 'lecture', { 
        customTitle: 'Lecture',
        path: path 
      });
    } else if (path === '/shorts') {
      updatePageMetaTags(config, 'shorts', { 
        customTitle: 'Shorts',
        customDescription: 'Watch short video clips from our lectures'
      });
    } else if (path === '/videos') {
      updatePageMetaTags(config, 'videos', { 
        customTitle: 'Videos',
        customDescription: 'Browse our video library'
      });
    } else {
      // For any other page, use a generic update
      updatePageMetaTags(config, 'page', { path });
    }

    console.log('[MetaTagsUpdater] Updated meta tags for route:', path);
  }, [location, config]);

  // This component doesn't render anything
  return null;
};

export default MetaTagsUpdater;